export { GoFile } from "./ast/core/GoFile.js";
export { type BaseGoCustomConfigSchema, baseGoCustomConfigSchema } from "./custom-config/BaseGoCustomConfigSchema.js";
export { defaultBaseGoCustomConfigSchema } from "./custom-config/DefaultBaseGoCustomConfigSchema.js";
export * as go from "./go.js";
export { goExportedFieldName } from "./utils/goExportedFieldName.js";
export { resolveRootImportPath, resolveRootModulePath } from "./utils/resolveRootImportPath.js";
